<template>
  <div>
    <v-layout wrap class="mb-3">
      <v-flex xs8>{{ $t('customer says') }}</v-flex>
      <v-flex v-if="$store.getters.getPackage == 'premium'" xs4 class="text-xs-right">
        <intent-prefill-question
          @onAddPrefill="onAddPrefill"
          @openDailogVerify="openDailogVerify"
        ></intent-prefill-question>
        <v-dialog v-model="dialogVerify" persistent>
          <v-card class="pa-2">
            <intent-prefill-verify-slip
              v-if="dialogVerify"
              :dialog-verify.sync="dialogVerify"
              :isVerify_slip.sync="isVerify_slip"
              :is-meta-verify-slip="isMetaVerifySlip"
              :is-event-purchase="isEventPurchase"
              :enable-event-purchase="isFacebookConversionConnected"
              :data-verify-slip.sync="dataVerifySlip"
              @onAddPrefill="onAddPrefill"
              @onAddPrefillMeta="onAddPrefillMeta"
              @onClickVerifySlip="onClickVerifySlip"
              @clearVerify="clearVerify"
            ></intent-prefill-verify-slip>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <template v-if="isVerify_slip">
      <h1 v-if="isMetaVerifySlip" style="color: #000; float: left; margin-top: 10px">
        Basic Slip Verification
      </h1>
      <div class="text-xs-right">
        <v-btn samll icon @click="openDailogVerify(isMetaVerifySlip ? 'meta' : '')">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn samll icon @click="clearToWayVerify">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div
        v-for="(item, index) in dataVerifySlip"
        :key="index"
        class="form-control intent-item z-border-red pa-3"
      >
        <div
          v-if="(item.status && item.status === 'pending') || item.id.includes('meta')"
          style="text-align: right; color: #fb8c00"
        >
          <small class="mr-2">ยังไม่ได้ยืนยันบัญชีบน META Business Suite</small>
          <i
            v-tooltip.top="$t('verify_on_meta')"
            class="fas fa-info-circle"
            style="font-size: 20px; vertical-align: middle"
          ></i>
        </div>
        <i
          v-if="item.status && item.status === 'verified'"
          v-tooltip.top="$t('Verified by Meta')"
          class="fas fa-check-circle green--text"
          style="float: right; font-size: 20px"
        ></i>
        <template v-if="item.typeAccount && item.typeAccount.value === 'all'">
          <div class="primary--text">
            {{ $t('bank_name') }} : <span> {{ $t('not_specified_account') }} </span>
          </div>
        </template>
        <template v-else>
          <v-layout wrap>
            <v-flex xs2>
              <img
                v-if="item.bankName && item.bankName === 'promptpay'"
                style="width: 40px"
                :src="'/static/img/assets/payment/logo_e_wallet/ewallet.png'"
              />
              <img
                v-else
                style="width: 40px"
                :src="
                  getBankName(item.bankName)
                    ? getBankName(item.bankName).image
                    : '/static/img/assets/_global/default-photo.png'
                "
              />
            </v-flex>
            <v-flex xs10>
              <div>
                <div v-if="item.bankName && item.bankName === 'promptpay'" class="primary--text">
                  {{ $t('promptpay') }}
                </div>
                <div v-else class="primary--text">
                  {{ $t('bank_name') }} :
                  <span v-if="getBankName(item.bankName)">{{
                    getBankName(item.bankName).name_th
                  }}</span>
                </div>
              </div>
              <div style="font-size: 90%">
                <div>
                  <span> {{ $t(paymentTitleType(item)) }} : </span>
                  <span>
                    <template v-if="item.typeAccount.value === 'meta'">xxxxxx</template
                    >{{ item.bankAccountNo }}</span
                  >
                </div>
                <div>
                  <span> {{ $t('receiver_name') }} :</span>
                  <span v-if="isMetaVerifySlip"> {{ item.name }} </span>
                  <template v-else>
                    <template v-if="item.keyword && item.keyword.length > 0">
                      <span v-for="(val, index) in item.keyword" :key="`name_text_${index}`">
                        {{ val.text }}
                        <span v-if="index !== item.keyword.length - 1">,</span></span
                      >
                    </template>
                    <span v-else> -</span>
                  </template>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </template>
      </div>
    </template>
    <div v-show="!isVerify_slip">
      <label class="caption" style="margin-bottom: 0px">
        {{ $t('Sentence') }}
      </label>
      <v-modal-help size="1em">
        <div slot="body">
          <div style="padding: 15px">
            <p class="strong">ตัวอย่าง:</p>
            <p>
              ตั้งค่าว่า:
              <span class="strong primary-color">"สอบถามค่าบริการสินค้าหน่อยค่ะ"</span>
              หากลูกค้าพิมพ์มาว่า "สอบถามค่าบริกานจ่ะ" กรณีนี้ถึงแม้ว่า ลูกค้าพิมพ์คำว่า
              <span class="strong primary-color">"บริกาน"</span> ผิด และใช้คำว่า
              <span class="strong primary-color">"จ่ะ"</span>
              แทนคำว่า
              <span class="strong primary-color">"ค่ะ"</span>
              เหมือนที่เราตั้งค่าไว้ บอทก็ยังเข้าใจและตอบกลับได้
            </p>
            <p>
              <span class="underline">Note:</span> พิมพ์ประโยคไปได้เยอะๆเพื่อให้บอทตอบได้แม่นยำขึ้น
            </p>
          </div>
        </div>
      </v-modal-help>
      <div class="form-control" :class="{ 'has-error': errorMessage['normal'] != '' }">
        <tags
          v-model="tag"
          style="margin-bottom: 5px"
          :tags="normal"
          :btn-text="$t('Add')"
          @tags-changed="
            (newTags) => {
              normal = newTags
              updateQuestion()
            }
          "
          @before-adding-tag="checkTag('normal', $event)"
        ></tags>
        <input v-model="normal" type="hidden" name="tag_normal" :data-vv-as="$t('question')" />
        <span v-show="errorMessage['normal'] != ''" class="text-error">{{
          errorMessage['normal'] != '' ? $t('Duplicate Question') : ''
        }}</span>
      </div>

      <label class="caption" style="margin-top: 10px">{{ $t('Keyword') }}</label>
      <v-modal-help size="1em">
        <div slot="body">
          <div style="padding: 15px">
            <p class="strong">ตัวอย่างแบบ1:</p>
            <p>
              การเซ็ทแบบคีย์เวิร์ดมีโอกาสผิดพลาดได้ ถ้าเซต
              <span class="strong primary-color">"ค่าบริการ"</span>ไว้ บอทจะดึงประโยคที่มีคำว่า
              <span class="strong primary-color">ค่าบริการ</span>ไปตอบทันที เช่น
              <span class="strong primary-color">ค่าบริการ</span>เท่าไหร่คะ และ
              <span class="strong primary-color">ค่าบริการ</span
              >โปรนี้ต่างจากค่าบริการโปรก่อนยังไงคะ มันจะตอบเหมือนกันทั้งที่จริงๆแล้ว
              มันเป็นคนละความหมาย
            </p>
            <div class="hr" style="margin-bottom: 15px"></div>
            <p class="strong">ตัวอย่างแบบ2:</p>
            <p>
              ตั้งค่าว่า:
              <span class="strong primary-color">"สอบถาม&&สินค้า"</span>
              หากลูกค้าพิมพ์ประโยคที่มีคำว่า
              <span class="strong primary-color">สอบถาม</span> และ
              <span class="strong primary-color">สินค้า</span> อยู่ในประโยคเดียวกัน
              บอทจะตอบตามที่ตั้งค่าทันที
            </p>
            <p><span class="underline">Note:</span> สัญลักษณ์ "&&" หมายถึง "และ"</p>
          </div>
        </div>
      </v-modal-help>

      <div class="form-control" :class="{ 'has-error': errorMessage['keyword'] != '' }">
        <tags
          v-model="tag"
          style="margin-bottom: 5px"
          :tags="keyword"
          :btn-text="$t('Add')"
          @tags-changed="
            (newTags) => {
              keyword = newTags
              updateQuestion()
            }
          "
          @before-adding-tag="checkTag('keyword', $event)"
        ></tags>
        <span v-show="errorMessage['keyword'] != ''" class="text-error">{{
          errorMessage['keyword'] != '' ? $t('Duplicate Question') : ''
        }}</span>
      </div>

      <label class="caption" style="margin-top: 10px">{{ $t('Exact word') }}</label>
      <v-modal-help size="1em">
        <div slot="body">
          <div style="padding: 15px">
            <p class="strong">ตัวอย่าง:</p>
            <p>
              ตั้งค่าว่า:
              <span class="strong primary-color">"สนใจ"</span>
              ลูกค้าต้องพิมพ์เหมือนคำที่ตั้งค่าไว้เป๊ะๆ บอทถึงจะสามารถตอบได้
              หากลูกค้าตกคำใดคำนึงหรือสะกดผิด บอทจะไม่สามารถตอบได้
            </p>
            <p>
              <strong>ยกตัวอย่างการตั้งค่า:</strong>
            </p>
            <table class="zw-table fullwidth text-xs-left">
              <tr>
                <th style="width: 50%; color: #d60000">
                  <em class="far fa-times-circle" style="font-size: 1.5em" /> ตัวอย่างที่ผิด
                </th>
                <th style="color: #4ab21e">
                  <em class="far fa-check-circle" style="font-size: 1.5em" /> ตัวอย่างที่ถูก
                </th>
              </tr>
              <tr>
                <td style="color: #d60000">สนใจค่ะ</td>
                <td style="color: #4ab21e">สนใจ</td>
              </tr>
              <tr>
                <td style="color: #d60000">สนใจครับ</td>
                <td></td>
              </tr>
            </table>
          </div>
        </div>
      </v-modal-help>

      <div class="form-control" :class="{ 'has-error': errorMessage['exactly'] != '' }">
        <tags
          v-model="tag"
          style="margin-bottom: 5px"
          :tags="exactly"
          :btn-text="$t('Add')"
          @tags-changed="
            (newTags) => {
              exactly = newTags
              updateQuestion()
            }
          "
          @before-adding-tag="checkTag('exactly', $event)"
        ></tags>
        <span v-show="errorMessage['exactly'] != ''" class="text-error">{{
          errorMessage['exactly'] != '' ? $t('Duplicate Question') : ''
        }}</span>
      </div>

      <div class="hr" style="margin-top: 20px"></div>
      <div class="text-xs-center" style="margin: -13px; margin-bottom: 10px">
        <a
          class="text btn-advanced"
          href="javascript:void(0);"
          style="position: relative"
          @click="onShowAdvance"
        >
          <!-- {{$t('Advanced')}} -->
          <em class="fa" :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }" />
          <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
        </a>
      </div>

      <div v-show="showAdvanced" style="margin-top: 5px">
        <label class="caption" for>{{ $t('Start with') }}</label>
        <v-modal-help size="1em">
          <div slot="body">
            <div style="padding: 15px">
              <p class="strong">เริ่มต้นด้วยคีย์เวิร์ด(Start with)</p>
              <p>Ex. ใส่เพิ่ม (02) แชทบอทจะเลือกตอบเมื่อลูกค้าพิมพ์เบอร์บ้านขึ้นต้น 02 ทันที</p>
            </div>
          </div>
        </v-modal-help>
        <template v-if="$store.getters.getPackage == 'premium'">
          <div class="form-control" :class="{ 'has-error': errorMessage['startwith'] != '' }">
            <tags
              v-model="tag"
              style="margin-bottom: 5px"
              :tags="startwith"
              :btn-text="$t('Add')"
              @tags-changed="
                (newTags) => {
                  startwith = newTags
                  updateQuestion()
                }
              "
              @before-adding-tag="checkTag('startwith', $event)"
            ></tags>
            <span v-show="errorMessage['startwith'] != ''" class="text-error">{{
              errorMessage['startwith'] != '' ? $t('Duplicate Question') : ''
            }}</span>
          </div>
        </template>
        <div v-else>
          <ul class="tags pl-0" style="margin-bottom: 5px">
            <li
              v-for="(question, index) in startwith"
              :key="'normal_question_' + index"
              class="tag"
              :class="{ disabled: true }"
            >
              <specialtext :text="question.text"></specialtext>
              <em class="mark fas fa-exclamation-circle" />
            </li>
            <li style="display: inline-block; text-align: center; position: relative">
              <v-premium-lock :inline="true" />
            </li>
          </ul>
        </div>

        <label class="caption" for style="margin-top: 10px">{{ $t('End with') }}</label>
        <v-modal-help size="1em">
          <div slot="body">
            <div style="padding: 15px">
              <p class="strong">ลงท้ายด้วยคีย์เวิร์ด(End with)</p>
              <p>Ex. ใส่เพิ่ม (.com) แชทบอทจะตอบเมื่อลูกค้าพิมพ์ลงท้ายด้วย .com ทันที</p>
            </div>
          </div>
        </v-modal-help>
        <template v-if="$store.getters.getPackage == 'premium'">
          <div class="form-control" :class="{ 'has-error': errorMessage['endwith'] != '' }">
            <tags
              v-model="tag"
              style="margin-bottom: 5px"
              :tags="endwith"
              :btn-text="$t('Add')"
              @tags-changed="
                (newTags) => {
                  endwith = newTags
                  updateQuestion()
                }
              "
              @before-adding-tag="checkTag('endwith', $event)"
            ></tags>
            <span v-show="errorMessage['endwith'] != ''" class="text-error">{{
              errorMessage['endwith'] != '' ? $t('Duplicate Question') : ''
            }}</span>
          </div>
        </template>
        <div v-else>
          <ul class="tags pl-0" style="margin-bottom: 5px">
            <li
              v-for="(question, index) in endwith"
              :key="'normal_question_' + index"
              class="tag"
              :class="{ disabled: true }"
            >
              <specialtext :text="question.text"></specialtext>
              <em class="mark fas fa-exclamation-circle" />
            </li>
            <li style="display: inline-block; text-align: center; position: relative">
              <v-premium-lock :inline="true" />
            </li>
          </ul>
        </div>

        <label class="caption" for style="margin-top: 10px">{{ $t('Start and End with') }}</label>
        <v-modal-help size="1em">
          <div slot="body">
            <div style="padding: 15px">
              <p class="strong">
                เริ่มต้นและลงท้ายด้วยคีย์เวิร์ด(Start and End with) -> (ใส่ คำเริ่ม && คำลงท้าย)
              </p>
              <p>
                Ex. ใส่เพิ่ม (www&&.com) แชทบอทจะตอบเมื่อลูกค้าพิมพ์ขึ้นต้นด้วย www และจบด้วย .com
              </p>
            </div>
          </div>
        </v-modal-help>
        <template v-if="$store.getters.getPackage == 'premium'">
          <div class="form-control" :class="{ 'has-error': errorMessage['startandendwith'] != '' }">
            <tags
              v-model="tag"
              style="margin-bottom: 5px"
              :tags="startandendwith"
              :btn-text="$t('Add')"
              @tags-changed="
                (newTags) => {
                  startandendwith = newTags
                  updateQuestion()
                }
              "
              @before-adding-tag="checkTag('startandendwith', $event)"
            ></tags>
            <span v-show="errorMessage['startandendwith'] != ''" class="text-error">
              <template v-if="errorMessage['startandendwith'] == 'duplicate'">{{
                $t('Duplicate Question')
              }}</template>
              <template v-else-if="errorMessage['startandendwith'] == 'requiredand'">{{
                $t('Please type && in between a word (Ex.www&&com)')
              }}</template>
            </span>
          </div>
        </template>
        <div v-else class="mb-3">
          <ul class="tags pl-0" style="margin-bottom: 5px">
            <li
              v-for="(question, index) in startandendwith"
              :key="'normal_question_' + index"
              class="tag"
              :class="{ disabled: true }"
            >
              <specialtext :text="question.text"></specialtext>
              <em class="mark fas fa-exclamation-circle" />
            </li>
            <li style="display: inline-block; text-align: center; position: relative">
              <v-premium-lock :inline="true" />
            </li>
          </ul>
        </div>
      </div>

      <label v-show="$store.getters.getPackage != 'premium'" class="caption pb-3">
        <em class="fas fa-exclamation-circle" />
        {{
          $t(
            'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
          )
        }}
      </label>
    </div>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'
import IntentPrefillQuestion from './IntentPrefillQuestion'
import specialtext from '@/components/elements/specialtext'
import { mapGetters } from 'vuex'
import IntentPrefillVerifySlip from './IntentPrefillVerifySlip'
import dayjs from 'dayjs'

export default {
  components: {
    Tags,
    IntentPrefillQuestion,
    specialtext,
    IntentPrefillVerifySlip
  },
  props: {
    value: {
      default: '',
      type: String
    },
    isBeacon: {
      type: Boolean,
      default: false
    },
    isEventPurchase: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isMetaVerifySlip: false,
      dataVerifySlip: [],
      isVerify_slip: false,
      dialogVerify: false,
      showAdvanced: false,
      result: '',
      tag: '',
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],

      errorMessage: {
        normal: '',
        keyword: '',
        exactly: '',
        startwith: '',
        endwith: '',
        startandendwith: ''
      },
      beaconData: {
        beacon_ids: '',
        beacon_type: '',
        group_audience: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isFacebookConversionConnected: 'isFacebookConversionConnected'
    }),
    isBbq() {
      return this.$store.state.bbqPage.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    value: function () {
      this.result = this.value
      this.formatData(this.value)
    },
    beaconData: {
      handler() {
        this.handleTransformBeaconData()
      },
      deep: true
    }
  },
  mounted: async function () {
    const vm = this
    vm.result = vm.value
    vm.formatData(vm.value)
    await vm.formatData(vm.value)
    if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.bank_info')) {
      try {
        vm.isVerify_slip = true
        const textSplitValue = vm.normal[0].text.split('{verify_slip.bank_info=')
        const textSplitValue2 = textSplitValue[1].split(',')
        const textValue = textSplitValue2[0].split('^')
        textValue[textValue.length - 1] = textValue[textValue.length - 1].split('}')[0]
        textValue.map((item, index) => {
          let typeAccount = null
          if (item.split('|')[0] === 'promptpay') {
            typeAccount = { value: 'promptpay', label: 'Promptpay' }
          } else if (item.split('|')[0].includes('ew')) {
            typeAccount = { value: 'eWallet', label: 'E-Wallet' }
          } else if (item.split('|')[0].includes('pg') || item.split('|')[0] === 'pgother') {
            typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
          } else {
            typeAccount = { value: 'transfer', label: 'Transfer' }
          }

          let keyword = []
          if (item.split('|') && item.split('|')[2]) {
            item
              .split('|')[2]
              .split('!')
              .forEach((element) => {
                keyword.push({ text: element })
              })
          }
          vm.dataVerifySlip.push({
            id: `${dayjs().format('x')}_${index}`,
            typeAccount: typeAccount,
            bankAccountNo: item.split('|')[1],
            bankName: item.split('|')[0],
            keyword: keyword
          })
        })
      } catch (error) {
        console.error(error)
      }
    } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.image}')) {
      vm.isVerify_slip = true
      vm.dataVerifySlip[0] = {
        id: dayjs().format('x'),
        typeAccount: { value: 'all', label: 'All' },
        bankAccountNo: '',
        bankName: '',
        keyword: ''
      }
    } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{meta_pay_verified}')) {
      vm.isVerify_slip = true
      vm.isMetaVerifySlip = true
      vm.dataVerifySlip = vm.$store.state.metaVerifySlip
    }
  },
  methods: {
    async clearToWayVerify() {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('delete_payment_method'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.clearVerify()
      }
    },
    paymentTitleType(item) {
      if (item.bankName && item.bankName === 'transfer') {
        return 'bank_account'
      } else if (item.bankName && item.bankName === 'promptpay') {
        return 'promptpay_code'
      } else if (item.typeAccount && item.typeAccount.value === 'eWallet') {
        return 'E-Wallet ID'
      } else if (item.typeAccount && item.typeAccount.value === 'paymentGateway') {
        return 'Biller ID'
      } else {
        return 'bank_account_no'
      }
    },
    getBankName(bankName) {
      const vm = this
      let bankAlltype = vm.$store.state.bankForVerify.concat(vm.$store.state.eWalletForVerify)
      bankAlltype = bankAlltype.concat(vm.$store.state.paymentGateway)
      return bankAlltype.filter((bankInfo) => bankInfo.value === bankName)[0]
    },
    async clearVerify() {
      const vm = this
      vm.dataVerifySlip = []
      vm.normal = []
      vm.isVerify_slip = false
      vm.isMetaVerifySlip = false
      vm.$emit('onClickClearVerifySlip')
    },
    onClickVerifySlip({ eventPurchase }) {
      const vm = this
      vm.$emit('onClickVerifySlip', { eventPurchase })
      vm.isVerify_slip = true
    },
    openDailogVerify: function () {
      this.dialogVerify = true
    },
    onAddPrefillMeta: function (payload) {
      const vm = this
      if (vm.isMetaVerifySlip) {
        vm.normal = []
        vm.keyword = []
        vm.exactly = []
        vm.startwith = []
        vm.endwith = []
        vm.startandendwith = []
        vm.normal = [{ text: '{meta_pay_verified}' }]
      }
      vm.dataVerifySlip = payload
    },
    onAddPrefill: function (payload) {
      const vm = this
      if (vm.isVerify_slip) {
        vm.normal = []
        vm.keyword = []
        vm.exactly = []
        vm.startwith = []
        vm.endwith = []
        vm.startandendwith = []
        vm.normal = [{ text: payload }]
      } else {
        vm.normal.push({ text: payload })
      }
      vm.dataVerifySlip = []
      if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.bank_info')) {
        try {
          const textSplitValue = vm.normal[0].text.split('{verify_slip.bank_info=')
          const textSplitValue2 = textSplitValue[1].split(',')
          const dataValue = textSplitValue2[0].split('^')
          dataValue[dataValue.length - 1] = dataValue[dataValue.length - 1].split('}')[0]
          dataValue.map((item, index) => {
            let typeAccount = null
            if (item.split('|')[0] === 'promptpay') {
              typeAccount = { value: 'promptpay', label: 'Promptpay' }
            } else if (item.split('|')[0].includes('ew')) {
              typeAccount = { value: 'eWallet', label: 'E-Wallet' }
            } else if (item.split('|')[0].includes('pg') || item.split('|')[0] === 'pgother') {
              typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
            } else {
              typeAccount = { value: 'transfer', label: 'Transfer' }
            }
            let keyword = []
            if (item.split('|') && item.split('|')[2]) {
              item
                .split('|')[2]
                .split('!')
                .forEach((element) => {
                  keyword.push({ text: element })
                })
            }
            vm.dataVerifySlip.push({
              id: `${dayjs().format('x')}_${index}`,
              typeAccount: typeAccount,
              bankAccountNo: item.split('|')[1],
              bankName: item.split('|')[0],
              keyword: keyword
            })
          })
        } catch (error) {
          console.error(error)
        }
      } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.image}')) {
        vm.dataVerifySlip[0] = {
          id: dayjs().format('x'),
          typeAccount: { value: 'all', label: 'All' },
          bankAccountNo: '',
          bankName: '',
          keyword: []
        }
      }
    },
    onShowAdvance: function () {
      this.showAdvanced = !this.showAdvanced
      // if (this.$store.getters.getPackage === 'premium') {
      // }
    },
    checkTag(type, obj) {
      this.errorMessage[type] = ''
      if (obj.tag.isDuplicate) {
        this.errorMessage[type] = 'duplicate'
        obj.error()
      } else if (type === 'startandendwith' && obj.tag.text.split('&&').length - 1 !== 1) {
        this.errorMessage[type] = 'requiredand'
        obj.error()
      } else obj.addTag()
    },
    formatData: function (text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.map(function (question, index) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({ text: keyword })
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword })
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({ text: keyword })
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword })
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({ text: keyword })
          } else {
            vm.normal.push({ text: question })
          }
        })
      }
    },
    updateQuestion: function () {
      this.result = ''
      var result = []
      var normal = []
      this.normal.map(function (key, index) {
        normal.push(key.text.trim())
      })
      if (normal && normal.length > 0) {
        result.push(normal.join(','))
      }

      var keyword = []
      this.keyword.map(function (key, index) {
        keyword.push('includes(' + key.text.trim() + ')')
      })
      if (keyword && keyword.length > 0) {
        result.push(keyword.join(','))
      }

      var exactly = []
      this.exactly.map(function (key, index) {
        exactly.push('exacts(' + key.text.trim() + ')')
      })
      if (exactly && exactly.length > 0) {
        result.push(exactly.join(','))
      }

      var startwith = []
      this.startwith.map(function (key, index) {
        startwith.push('startswith(' + key.text.trim() + ')')
      })
      if (startwith && startwith.length > 0) {
        result.push(startwith.join(','))
      }

      var endwith = []
      this.endwith.map(function (key, index) {
        endwith.push('endswith(' + key.text.trim() + ')')
      })
      if (endwith && endwith.length > 0) {
        result.push(endwith.join(','))
      }

      var startandendwith = []
      this.startandendwith.map(function (key, index) {
        startandendwith.push('startsendswith(' + key.text.trim() + ')')
      })
      if (startandendwith && startandendwith.length > 0) {
        result.push(startandendwith.join(','))
      }

      //   this.result = result.join(',')
      this.$emit('input', result.join(','))
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentQuestion.vue